import { BOT_DEPLOYMENTS_CHANNELS } from './main';

export const FORM_CONFIGURATION_WEBCHAT_INTEGRATION_PATH = ['settings', 'integration', 'microsoftWebChat'];
export const FORM_CONFIGURATION_WEBCHAT_ALLOWED_ORIGINS_PATH = ['settings', 'allowedOrigins'];
export const FORM_CONFIGURATION_WEBCHAT_LAYOUT_PATH = ['settings', 'layout', 'microsoftWebChat', 'configuration'];
export const FORM_CONFIGURATION_VIBER_INTEGRATION_PATH = ['settings', 'integration', 'viber'];
export const FORM_CONFIGURATION_MS_TEAMS_INTEGRATION_PATH = ['settings', 'integration', 'microsoftTeams'];
export const FORM_CONFIGURATION_FACEBOOK_INTEGRATION_PATH = ['settings', 'integration', 'facebook'];
export const FORM_CONFIGURATION_SLACK_INTEGRATION_PATH = ['settings', 'integration', 'slack'];
export const FORM_CONFIGURATION_INSTAGRAM_INTEGRATION_PATH = ['settings', 'integration', 'instagram'];
export const FORM_CONFIGURATION_WHATSAPP_INTEGRATION_PATH = ['settings', 'integration', 'whatsapp'];
export const FORM_CONFIGURATION_API_INTEGRATION_PATH = ['settings', 'integration', 'api'];
export const FORM_CONFIGURATION_UNITY_INTEGRATION_PATH = ['settings', 'integration', 'unity'];
export const FORM_CONFIGURATION_ZENDESK_INTEGRATION_PATH = ['settings', 'integration', 'zendesk'];
export const FORM_CONFIGURATION_ZENDESK_LAYOUT_PATH = ['settings', 'layout', 'zendesk'];

export const FLOW_SUPPORTED_PLATFORMS = {
  [BOT_DEPLOYMENTS_CHANNELS.MICROSOFT_WEB_CHAT.key]: FORM_CONFIGURATION_WEBCHAT_LAYOUT_PATH,
  [BOT_DEPLOYMENTS_CHANNELS.ZENDESK.key]: FORM_CONFIGURATION_ZENDESK_LAYOUT_PATH
};

